// For tall tooltips (e.g. a recording's title/description in two languages): wider so they're shorter
// (minus a 16px gutter on narrow screens), and kept inside the viewport — overlapping the anchor —
// when they fit neither above nor below.
export const LARGE_TOOLTIP_SLOT_PROPS = {
	tooltip: {
		sx: {
			maxWidth: 'min(480px, calc(100vw - 32px))',
		},
	},
	popper: {
		modifiers: [{
			name: 'preventOverflow',
			options: {
				altAxis: true,
				tether: false,
				padding: 8,
			},
		}],
	},
};
